import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MessagesPage from "./pages/MessagesPage";
import StocksPage from "./pages/StocksPage";
import "./App.css";

function App() {
  return (
    <Routes>
      <Route path="/" element={<MessagesPage />} />
      <Route path="/stocks" element={<StocksPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
